import styled, {css} from 'styled-components'

export const StyledMemberCard = styled.div(
    ({theme: {palette, spacing}}) => css`
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        background-color: ${palette.neutral.white};
        width: 100%;
    `
)

export const StyledMemberCardWrapper = styled.div(
    () => css`
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        width: 100%;
        align-items: end;
    `
)
